import { HeaderSidebar } from "../../../components/Header/HeaderSidebar";
import { Field, FieldArray, Form, Formik } from "formik"
import { useEffect, useState } from "react"
import { getClassName } from "../../../utils";
import { TextareaAutosize } from "@mui/material";
import { AddMore } from "../../../components/Buttons/AddMoreButton";
import { StepperButtons } from "../../../components/Stepper/Buttons";
import { useNavigate } from "react-router-dom";
import { getValuesForm } from "../../../services/autofillService";
import { Step } from "../../../components/Step/Step";
import { questions, videos } from "../../../content/personality/values";
import { ProgressLine } from "../../../components/Progress/Line";
import { submitValues } from "../../../services/answersService";

export const PersonalityValues = () => {
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({
        personalityValues: [
            {
                personalityValue: '',
            }
        ]
    });
    const [showNext, setShowNext] = useState(false);

    const handleSubmit = values => {
        setIsLoading(true);
        submitValues(values).then(response => {
            setIsLoading(false);
            navigate("/flow/personality/look");
        }).catch(err => {
            setIsLoading(false);
            console.error(err)
        })
    }

    useEffect(() => {
        getValuesForm().then(response => {
            const data = response.data;
            if (data) {
                setInitialValues(data);
                setShowNext(true);
            }
        }).catch(err => {
            console.log(err);
        })
    }, []);
    return (
        <>
            <ProgressLine />
            <section className="h-dvh overflow-hidden flex flex-col items-center justify-center">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched }) => (
                        <>
                            <Form className="w-full max-w-[35%] h-full relative flex flex-col items-start justify-center">
                                <section className="flex flex-col items-center justify-center w-full h-full">
                                    <Step className={getClassName(0, activeStep)} question={questions.personalityValues} url={videos.personalityValuesVideo.url}>
                                        <FieldArray name="personalityValues">
                                            {({ insert, remove, push }) => (
                                                <>
                                                    {values.personalityValues.length > 0 &&
                                                        values.personalityValues.map((personalityValue, index) => (
                                                            <Field
                                                                name={`personalityValues.${index}.personalityValue`}
                                                                placeholder="Value"
                                                                className="has-border-bottom mt-3"
                                                                key={index}
                                                                as={TextareaAutosize}
                                                            />
                                                        ))
                                                    }
                                                    <AddMore onClick={() => push({ personalityValue: '' })} />
                                                </>
                                            )}
                                        </FieldArray>
                                    </Step>
                                </section>
                                <section className="flex w-full items-center mb-[10%] justify-between z-10">
                                    <StepperButtons
                                        link="/flow/personality/introduction"
                                        isLoading={isLoading}
                                        showNext={showNext || activeStep === 0}
                                    />
                                </section>
                            </Form>
                        </>
                    )}
                </Formik>
            </section>
            <HeaderSidebar activeEl="Personality & Charisma" />
        </>
    )
}